import React, { useEffect, useContext, useMemo, useRef } from 'react'
import { PlayerContext } from '@store/player'

function Player() {

  const { state, dispatch } = useContext(PlayerContext)

  const player = useRef(null)

  const playerStyle = {
    position: 'absolute',
    width: 0,
    height: 0,
    zIndex: -100,
  }

  const songUrl = useMemo(() => {
    return `./songs/${state.current}.mp3`
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.current])

  useEffect(() => {
    if (player.current && songUrl) {
      console.log('addEventListener')
      player.current.addEventListener('loadeddata', onLoadedData)
      player.current.addEventListener('oncanplay', onCanPlay)
      player.current.addEventListener('ended', onEnded)
      return function () {
        console.log('removeEventListener')
        player.current.removeEventListener('loadeddata', onLoadedData)
        player.current.removeEventListener('oncanplay', onCanPlay)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        player.current.removeEventListener('ended', onEnded)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.current])

  function onLoadedData() {}

  function onCanPlay() {
    player.current.play()
  }

  function onEnded () {
    if (state.current === 5) {
      dispatch({ type: "setCurrent", current: 1 })
    } else {
      dispatch({ type: "setCurrent", current: state.current + 1 })
    }
  }

  return (
    <audio id='player' ref={player} src={songUrl} autoPlay style={playerStyle}></audio>
  )
}

export default Player
